import { isValidElement } from "react";

export interface IfProps {
  children: React.ReactNode;
  condition: any;
}

/** @deprecated Please use inline boolean conditionals to render JSX */
export const If = ({ condition, children }: IfProps) => {
  const renderChildren =
    typeof children === "function"
      ? children
      : () => {
          if (isValidElement(children)) {
            return children;
          }
          return null;
        };
  return condition ? renderChildren() : null;
};
